import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { bankFilePaymentsAPI } from 'redux/bankFilePaymentsAPI';
import { showSnackbar } from 'redux/snackbar';
import i18n from 'i18next';
import type { MerchantAdminState } from 'redux/store';
import { DetailedBankFilePaymentResponse } from '@payer-admin-ui/api/src/bankfilepayments/bankFilePaymentTypes';
import { fetchBankFilePayment } from '../bankFilePaymentsGlobalState';

type MarkAsDoNotMapIgnoredParams = {
  bankFilePaymentId: string;
};

export const markAsDoNotMapIgnored = createAsyncThunk<
  DetailedBankFilePaymentResponse,
  MarkAsDoNotMapIgnoredParams,
  { state: MerchantAdminState }
>(
  'bankFilePayments/markAsDoNotMapIgnoredDialog/ignore',
  async ({ bankFilePaymentId }: MarkAsDoNotMapIgnoredParams, { dispatch }) => {
    const result = await bankFilePaymentsAPI.bankFilePayments.doNotMap({ bankFilePaymentId, reason: 'IGNORED' });
    dispatch(fetchBankFilePayment({ bankFilePaymentId }));
    dispatch(
      showSnackbar(i18n.t('bankFilePayments.actions.markAsDoNotMapIgnored.success', { bankFilePaymentId }), {
        severity: 'success',
      }),
    );
    return result;
  },
);

type DialogState = {
  isFetching: boolean;
  success: boolean | null;
  error: any;
};

type SliceState = Record<string, DialogState | undefined>;

const markAsDoNotMapIgnoredDialogSlice = createSlice({
  name: 'bankFilePayments/actions/markAsDoNotMapIgnoredDialog',
  initialState: {} as SliceState,
  reducers: {
    reset: (state, { payload: { bankFilePaymentId } }: { payload: { bankFilePaymentId: string } }) => {
      state[bankFilePaymentId] = undefined;
    },
  },
  extraReducers: builder => {
    builder.addCase(markAsDoNotMapIgnored.pending, (state, { meta: { arg } }) => {
      state[arg.bankFilePaymentId] = { isFetching: true, success: null, error: null };
    });
    builder.addCase(markAsDoNotMapIgnored.fulfilled, (state, { meta: { arg } }) => {
      state[arg.bankFilePaymentId] = { isFetching: false, success: true, error: null };
    });
    builder.addCase(markAsDoNotMapIgnored.rejected, (state, { meta: { arg }, error }) => {
      state[arg.bankFilePaymentId] = { isFetching: false, success: false, error };
    });
  },
});

export const {
  actions: { reset },
  reducer: markAsDoNotMapIgnoredDialogReducer,
} = markAsDoNotMapIgnoredDialogSlice;
